import { MouseEvent, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "components/button/default";
import { useMutation } from "@tanstack/react-query";
import { chkPromCdApi } from "components/api/comm";
import { alertControl, modalControl, successControl } from "util/commAction";
// import { useBookInfContext } from "components/context/bookInfContext";
import { useNavigate } from "react-router-dom";
import "./promCd.scss";

export default function PromCdModalInner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = new URLSearchParams();
  const [promCd, setPromCd] = useState("");
  params.set("promCd", promCd);

  // const { promCd, setPromCd } = useBookInfContext();
  // const promCdRef = useRef("");
  const [isAvailable, setIsAvailable] = useState(false);

  const chkPromMutation = useMutation({
    mutationFn: chkPromCdApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            alertControl({
              isOpen: true,
              inner: "사용이 가능한 프로모션 코드입니다.",
            });
            setIsAvailable(true);
          },
        });
      }
    },
  });

  const handleSearch = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    chkPromMutation.mutate(promCd);
  };

  return (
    <div className="prom-inner">
      <h3 className="">{t("btn_hm_app_prmCd")}</h3>
      <sub className="text-gray-600 mb-[8px]">{t("dscrp_hm_md_prm")}</sub>
      <div className="center pt-2">
        <div>
          <input type="radio" id="sell" name="promCd" defaultChecked />
          <label htmlFor="sell" className="no-check">
            {t("sb_ttl_hm_md_sl_code")}
          </label>
        </div>
        <div>
          <input type="radio" name="promCd" id="cmp" />
          <label htmlFor="cmp" className="no-check">
            {t("sb_ttl_hm_md_crprt_code")}
          </label>
        </div>
      </div>
      <form className="prom-inf">
        <input
          type="text"
          placeholder={t("txt_hm_md_in_code")}
          onChange={(e) => {
            setPromCd(e.currentTarget.value);
            // if (promCdRef.current) {
            //   promCdRef.current = e.currentTarget.value;
            // }
          }}
        />
        <Button
          text={t("btn_hm_md_inq")}
          styels="font-14 px-2"
          disabled={!promCd}
          onClick={handleSearch}
        />
      </form>
      <div className="center">
        <Button
          text={t("btn_hm_md_app_code")}
          styels="w-[116px] font-14 "
          disabled={!isAvailable}
          onClick={() => {
            if (isAvailable) {
              // setPromCd(promCdRef.current);
              navigate(`?${params.toString()}`);
              modalControl({
                isOpen: false,
              });
            }
          }}
        />
      </div>
    </div>
  );
}
